import { MatrixCategory, MatrixCriterion } from '../../../../types/advise';

export interface SelectionCount {
  selected: number;
  total: number;
  custom: number;
}

// As in the Figma drill-down, "[n] of [m]" counts the category's own features and "+ [k] custom" the ones added to it.
export const categoryCount = (category: MatrixCategory): SelectionCount => {
  const own = category.custom ? category.features : category.features.filter((feature) => !feature.custom);
  return {
    selected: own.filter((feature) => feature.selected).length,
    total: own.length,
    custom: category.features.length - own.length
  };
};

export const selectionCountLabel = ({ selected, total, custom }: SelectionCount) =>
  `${selected} of ${total} selected${custom > 0 ? ` + ${custom} custom` : ''}`;

// The sum of its categories, so the two levels always agree.
export const criterionCount = (criterion: MatrixCriterion): SelectionCount =>
  criterion.categories.map(categoryCount).reduce(
    (sum, count) => ({
      selected: sum.selected + count.selected,
      total: sum.total + count.total,
      custom: sum.custom + count.custom
    }),
    { selected: 0, total: 0, custom: 0 }
  );

/** The Criteria Weighting header: how many criteria are selected, of how many, and their total weight. */
export const weightingSummary = (criteria: MatrixCriterion[]) => {
  const selected = criteria.filter((criterion) => criterion.selected);
  return {
    selected: selected.length,
    total: criteria.length,
    totalWeight: selected.reduce((sum, criterion) => sum + (criterion.weight ?? 0), 0),
    unweighted: selected.filter((criterion) => !criterion.weight).map((criterion) => criterion.label)
  };
};
